<app-switch-checkbox
  *ngFor="let category of accountCategories"
  bsClass="success"
  [checked]="filter.includes(category.code)"
  (change)="filterByCategory.emit({ category: category.code, toggle: $event })"
>
  {{ category.displayName }}
</app-switch-checkbox>
